import React from 'react';
import { AppRouter } from './AppRouter';
import { ActivityProvider } from './contexts/ActivityContext';
import { TagsProvider } from './contexts/TagsContext';
import { AppDataProvider } from './contexts/AppDataContext';
import { TaskProvider } from './contexts/TaskContext';
import { LoyaltyAuditProvider } from './contexts/LoyaltyAuditContext';
import { AppModeProvider } from './contexts/AppModeContext';
import { ReportSettingsProvider } from './contexts/ReportSettingsContext';
export function App() {
  return <AppModeProvider data-id="element-0" data-mp="2mmvlkvs92ic2">
      <AppDataProvider data-id="element-1" data-mp="2mndqshww46w4">
        <TaskProvider data-id="element-2" data-mp="2mjzlp1wudjkz">
          <ActivityProvider data-id="element-3" data-mp="31agpgrwy8ll1">
            <TagsProvider data-id="element-4" data-mp="31brzh9gzmpkl">
              <LoyaltyAuditProvider data-id="element-5" data-mp="31c1iue7j1yhb">
                <ReportSettingsProvider data-id="element-6" data-mp="2wka0gqyiyz29">
                  <AppRouter data-id="element-7" data-mp="2wj8fnurpiy7c" />
                </ReportSettingsProvider>
              </LoyaltyAuditProvider>
            </TagsProvider>
          </ActivityProvider>
        </TaskProvider>
      </AppDataProvider>
    </AppModeProvider>;
}